import { useQuery } from '@tanstack/react-query'
import { Spinner } from '.'

const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST
const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_PERSONAL_API_KEY
const PROJECT_ID = import.meta.env.VITE_POSTHOG_PROJECT_ID

async function posthogQuery(query: string): Promise<number> {
  const res = await fetch(`${POSTHOG_HOST}/api/projects/${PROJECT_ID}/query/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${POSTHOG_API_KEY}`,
    },
    body: JSON.stringify({
      query: { kind: 'HogQLQuery', query },
    }),
  })
  if (!res.ok) throw new Error(`PostHog query failed: ${res.status}`)
  const data = await res.json()
  return Number(data.results?.[0]?.[0]) || 0
}

const enabled = Boolean(POSTHOG_HOST) && Boolean(POSTHOG_API_KEY)

export const PosthogStatistics = () => {
  const visitors = useQuery({
    queryKey: ['posthog', 'unique-visitors'],
    queryFn: () =>
      posthogQuery(
        'SELECT count(DISTINCT distinct_id) FROM events WHERE timestamp >= now() - INTERVAL 30 DAY',
      ),
    enabled,
    staleTime: 1000 * 60 * 60,
  })

  const pageviews = useQuery({
    queryKey: ['posthog', 'species-pageviews'],
    queryFn: () =>
      posthogQuery(
        `SELECT count() FROM events WHERE event = '$pageview' AND timestamp >= now() - INTERVAL 30 DAY AND not(match(toString(properties.$host), '^(localhost|127\\\\.0\\\\.0\\\\.1)($|:)')) AND ilike(toString(properties.$current_url), '%/species/%')`,
      ),
    enabled,
    staleTime: 1000 * 60 * 60,
  })

  if (!enabled) return null

  const isLoading = visitors.isLoading || pageviews.isLoading

  return (
    <>
      <h3 className="mb-2 mt-6 text-lg font-bold text-gray-800">
        Usage Statistics
      </h3>
      {isLoading && <Spinner />}
      {!isLoading && (
        <div>
          <p>In the last 30 days, SID has received:</p>
          <div className="mt-5 grid w-full grid-cols-8 gap-2">
            {visitors.data != null && (
              <div className="rounded-md border border-gray-300 p-4">
                <span className="block font-bold text-serblue-dark">
                  Unique Visitors
                </span>
                {visitors.data.toLocaleString()}
              </div>
            )}
            {pageviews.data != null && (
              <div className="rounded-md border border-gray-300 p-4">
                <span className="block font-bold text-serblue-dark">
                  Species Profile Views
                </span>
                {pageviews.data.toLocaleString()}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
